
import { Component, Vue } from 'vue-property-decorator';

@Component<CateringBotPrompt>({})
export default class CateringBotPrompt extends Vue {
}
